var _path, _path2, _rect, _line, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8569 17.1516L26.68 14.3145L31.5031 17.1516M21.8569 17.1516L26.68 19.9887M21.8569 17.1516V22.8258L26.68 25.8047M26.68 19.9887L31.5031 17.1516M26.68 19.9887V25.8047M31.5031 17.1516V22.8258L26.68 25.8047",
    stroke: "#54555A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.68 14.3145V19.8468M26.68 19.8468L31.5031 22.8258M26.68 19.8468L21.8569 22.8258",
    stroke: "#54555A",
    strokeDasharray: "1 1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 36,
    height: 32.9538,
    rx: 6.5,
    stroke: "#54555A",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.2002,
    y1: 2.33984,
    x2: 17.2002,
    y2: 34.0198,
    stroke: "#54555A",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14014,
    y: 5.7998,
    width: 8.92,
    height: 8.92,
    rx: 2.5,
    stroke: "#54555A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.70d77d65857eab0aa74adbd3885be6ef.svg";
export { ForwardRef as ReactComponent };